<template>
	<div class="code-details">
		<section class="code-details__primary">
			<span class="code-details__label">Code ID</span>
			<span class="code-details__value">{{ snippet.id }}</span>
		</section>
		<section class="code-details__secondary">
			<span class="code-details__label">Description</span>
			<p class="code-details__value">
				{{ snippet.description }}
			</p>
		</section>
		<section class="code-details__tertiary">
			<span class="code-details__label">Code</span>
			<p class="code-details__value">
				{{ snippet.snippetCalc }}
			</p>
		</section>
		<section class="code-details__quartery">
			<ul class="code-details-group">
				<li
					class="code-details-group__item"
					v-show="showSnippetAttribute"
				>
					<span class="code-details__label">Attribute</span>
					<span class="code-details__value">
						{{ mappingSnippetAttribute }}
					</span>
				</li>
				<li class="code-details-group__item">
					<span class="code-details__label">Format</span>
					<span class="code-details__value">{{
						snippet.snippetFormat
					}}</span>
				</li>
				<li class="code-details-group__item">
					<span class="code-details__label">Justification</span>
					<span class="code-details__value">{{
						snippet.snippetJustify
					}}</span>
				</li>
			</ul>
		</section>
	</div>
</template>
<script>
import { mappingAttribute } from '@/views/shared/snippet-attribute.js';

export default {
	name: 'CodeDetails',
	props: {
		snippet: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		mappingSnippetAttribute() {
			return mappingAttribute[this.snippet.snippetAttribute];
		},
		showSnippetAttribute() {
			return !!this.snippet.snippetAttribute;
		}
	}
};
</script>
<style lang="scss">
.code-details {
	overflow: hidden;
	display: grid;
	gap: $gutter-xl;
	grid-template-columns: 1fr 1fr 1fr;

	&__primary,
	&__secondary {
		grid-column: 1/4;
	}

	&__primary,
	&__secondary,
	&__quartery,
	&__quinary {
		display: flex;
		flex-direction: column;
	}

	&__secondary,
	&__quartery {
		.code-details__value {
			word-break: break-word;
		}
	}

	&__label {
		font-weight: $medium-font-weight;
		margin-bottom: $gutter-md;
		font-size: $default-font-size - 2;
	}
	&__value {
		font-size: $default-font-size - 2;
		overflow-wrap: break-word;
	}

	&__tertiary,
	&__quartery,
	&__quinary {
		grid-column: 1/4;
	}

	&-group {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: $gutter-xl;

		@include mq($from: sm-l) {
			grid-template-columns: 1fr 1fr 1fr;
		}

		&__item {
			flex-direction: column;
			display: inline-flex;
		}
	}
}
</style>
